import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';
import { Stack } from 'shared/mui/Stack/Stack';

export const MethodLogosEditFormSkeleton: React.FC = () => {
  return (
    <>
      <Box py={3}>
        <Skeleton height={40} variant="rounded" width="100%" />
        <Skeleton height={158} sx={{ marginTop: '24px' }} variant="rounded" width="100%" />
      </Box>
      <Stack direction="row" gap={2} justifyContent="flex-end">
        <Skeleton height={36} variant="rounded" width={100} />
        <Skeleton height={36} variant="rounded" width={116} />
      </Stack>
    </>
  );
};
